import type { SVGProps } from 'react'
const SvgSyShieldCheck = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			d="m15.545 4.52 2.849 1.22a1 1 0 0 1 .606.92v6.252a6 6 0 0 1-2.513 4.883l-3.906 2.79a1 1 0 0 1-1.162 0l-3.906-2.79A6 6 0 0 1 5 12.912V6.66a1 1 0 0 1 .606-.919l2.849-1.22a9 9 0 0 1 7.09 0"
		/>
		<path d="M15.146 10.146 11.5 13.793l-1.646-1.647-.708.708 1.895 1.894c.25.25.668.25.918 0l3.895-3.894z" />
	</svg>
)
export default SvgSyShieldCheck
